import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Helmet from 'react-helmet';
import { Layout } from 'antd';
import { screenBreakpoints, useAppContext } from 'App/app-context';
import { useAppSubdomain } from 'hooks/useAppSubdomain';
import DashboardPageHeader from '../DashboardPageHeader';
import { DashpageContext } from './dashpage-context';
import styles from './style.module.less';
const DashboardPage = ({ title, toolbar, extraControls, children, }) => {
    const { pageTitle } = useAppSubdomain(title);
    const { screenSize } = useAppContext();
    const headerHeight = screenSize.width < screenBreakpoints.md ? 90 : 45;
    const contextValue = useMemo(() => ({
        contentHeight: screenSize.height - headerHeight,
    }), [screenSize.height, headerHeight]);
    return (_jsxs(Layout.Content, { className: styles.dashpage, children: [_jsx(Helmet, { title: pageTitle }), _jsxs(DashpageContext.Provider, { value: contextValue, children: [_jsx(DashboardPageHeader, { extraControls: extraControls, children: toolbar !== null && toolbar !== void 0 ? toolbar : null }), _jsx(Layout.Content, { className: styles.dashpageContent, children: typeof children === 'function' ? children(contextValue) : children })] })] }));
};
export default DashboardPage;
